module.exports = __webpack_public_path__ + "static/media/Petroleum.649445f5.mp4";